import routes from '../../config/routes';

export const isAvailabiltyRoute = () => {
  return location.pathname.includes(routes.availability);
};

export const isRescheduleRoute = () => {
  return location.pathname.includes(routes.reschedule);
};
